import React, { useRef, useState, useEffect } from "react";
import MaterialTable from "material-table";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton, TableCell, TableHead, TableRow } from "@material-ui/core";
import { Row } from "react-bootstrap";
import TablePagination from "@material-ui/core/TablePagination";
import ModalConfirmAction from "../ModalConfirmAction/ModalConfirmAction";
import {
  GeneralStylePublic,
  useStyles,
  TableActions,
  RightSection,
  ContentDownloadFile,
  TextDownloadFile,
  ContentFilters,
} from "./AdminPublicGuestsComponent.styled";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import { Checkbox } from "@mui/material";
import { purple } from "@mui/material/colors";
import moment from "moment";
import ReactCountryFlag from "react-country-flag";
import ExportExcelFile from "../ReportSurveyBlock/ExportExcelFile/ExportExcelFile";
import { DeleteTwoTone } from "@material-ui/icons";
import SearchComponent from "../SearchComponent/SearchComponent";
import GeneralFiltersContainer from "../../containers/GeneralFiltersContainer/GeneralFiltersContainer";
import { theme as themeConfig } from "../../themes/themes";

const label = { inputProps: { "aria-label": "Checkbox attendance" } };

const AdminPublicGuestsComponent = ({
  data,
  eventDate,
  nameEvent,
  handleChangePage,
  handleChangeRowsPerPage,
  hadleDeleteParticipant,
  rowsPerPageOptions,
  rowsPerPage,
  page,
  allPages,
  handleCheckAttendance,
  dataDownloadAttendees,
  handleDownloadAttendees,
  FilterEvents,
  setDataFilter,
  filtered,
  setFiltered,
  allAttended,
  handleCheckAllAttendance
}) => {
  const classes = useStyles();
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [showCards, setShowCards] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const rSearch = useRef();
  const [searchText, setSearchText] = useState("");

  let handleClickActions = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setAnchorSelected(rowData.id);
  };

  let handleCloseActions = () => {
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  let deleteSurvey = (rowData) => {
    hadleDeleteParticipant(rowData);
    setOpenDeleteModal(null);
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete the guest?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={deleteSurvey}
      />
    ) : null;
  };

  const getDataBySearch = () => {
    setSearchText(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  useEffect(() => {
    FilterEvents(searchText);
  }, [searchText]);

  const filtersViews = {
    countries: true,
    cities: true,
    search: {
      show: false,
      label: "Name - Last Name - Email",
    },
  };

  return (
    <GeneralStylePublic>
      <TableActions>
        <label>Guest | {nameEvent}</label>
        <RightSection>
          <ContentFilters>
            <GeneralFiltersContainer
              filtersViews={filtersViews}
              FilterEvents={FilterEvents}
              setDataFilter={setDataFilter}
              filtered={filtered}
              setFiltered={setFiltered}
            />
          </ContentFilters>
          <SearchComponent
            rSearch={rSearch}
            handleSearch={handleSearch}
            setSearchText={setSearchText}
          />
          <ContentDownloadFile
            className="mt-2"
            onClick={() => handleDownloadAttendees()}
          >
            <ExportExcelFile
              data={dataDownloadAttendees}
              nameFile={"downloaded-guests"}
              withIcon={true}
            ></ExportExcelFile>
            <TextDownloadFile style={{ paddingLeft: "5px" }}>
              Download
            </TextDownloadFile>
          </ContentDownloadFile>
        </RightSection>
      </TableActions>
      {!showCards && (
        <MaterialTable
          title={nameEvent}
          columns={[
            {
              title: "Attendance",
              field: "attendanceCheck",
              sorting: false,
              type: "string",
              render: (rowData) => {
                let now = moment();
                let date = moment(eventDate, "DD/MM/YYYY");
                return (
                  <>
                    <Checkbox
                      {...label}
                      defaultChecked={rowData.attendanceCheck}
                      checked={rowData.attendanceCheck}
                      sx={{
                        color: purple[400],
                        "&.Mui-checked": {
                          color: purple[400],
                        },
                      }}
                      onClick={() =>
                        handleCheckAttendance(rowData, rowData.attendanceCheck)
                      }
                    />
                  </>
                );
              },
            },
            {
              title: "First Name",
              field: "firstName",
              type: "string",
            },
            {
              title: "Last Name",
              field: "lastName",
              type: "string",
            },
            {
              title: "Email",
              field: "Email",
              type: "string",
            },
            {
              title: "Country",
              field: "country",
              type: "string",
              render: (rowData) => {
                return (
                  <ReactCountryFlag
                    svg
                    countryCode={rowData.country}
                    style={{
                      width: "1.5rem",
                      height: "1.5rem",
                      borderRadius: "8px",
                    }}
                  />
                );
              },
            },
            {
              title: "City",
              field: "city",
              type: "string",
            },
            {
              title: "Registration Date",
              field: "registrationDateFormatted",
              type: "string",
            },
            {
              title: "Delete",
              field: "internal_action",
              sorting: false,
              cellStyle: {
                padding: "0px 6px",
              },
              headerStyle: {
                padding: "0px",
              },
              render: (rowData) =>
                rowData && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Delete">
                      <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        className={classes.active}
                        onClick={(e) => setOpenDeleteModal(rowData)}
                      >
                        <DeleteTwoTone />
                      </IconButton>
                    </Tooltip>
                  </div>
                ),
            },
          ]}
          data={data}
          components={{
            Header: props => (
                <TableHead>
                  <TableRow>
                    {props.columns.map((column, idx) => {
                      // return only the real columns
                      return column.title !== "Attendance" ? (
                        <TableCell key={idx}>{column.title}</TableCell>
                      ) : 
                      <TableCell style={{
                        paddingLeft: '10px'
                      }}>
                        <p style={{ margin : 0 }}>Attendance</p>
                      <Checkbox
                        sx={{
                          color: purple[400],
                          "&.Mui-checked": {
                            color: purple[400],
                          },
                        }}
                        defaultChecked={allAttended}
                        onClick={handleCheckAllAttendance}
                      />
                    </TableCell>
                    })}
                  </TableRow>
                </TableHead>
            ),
           }}
          options={{
            maxBodyHeight: 450,
            paging: false,
            search: false,
            headerStyle: {
              zIndex: 0,
              fontWeight: "bold",
            },
            cellStyle: {
              padding: "5px 10px",
            },
          }}
        ></MaterialTable>
      )}
      {showCards && (
        <ViewControlMenu
          identity={"public-guests"}
          title={"Performance Talk"}
          showCards={showCards}
          setShowCards={setShowCards}
          list={data}
          isAgent={false}
          handleClickActions={handleClickActions}
          anchorSelected={anchorSelected}
          anchorEl={anchorEl}
          handleCloseActions={handleCloseActions}
          setAnchorEl={setAnchorEl}
          setAnchorSelected={setAnchorSelected}
          setOpenDeleteModal={setOpenDeleteModal}
        />
      )}
      <Row style={{ backgroundColor: themeConfig.neutral.white, margin: "0" }}>
        {allPages > 0 && rowsPerPage && rowsPerPageOptions && (
          <TablePagination
            component="div"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
            }}
            count={allPages}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={rowsPerPageOptions}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </Row>
      {showDeleteModal()}
    </GeneralStylePublic>
  );
};
export default AdminPublicGuestsComponent;
